module.exports = "/_next/static/images/icon-broker-income-f95c1322.png";